var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"headtop of"},[_c('div',{staticClass:"headtopL",on:{"click":function($event){return _vm.$router.back()}}}),_c('div',{staticClass:"headtopM"},[_vm._t("default")],2),_c('div',{staticClass:"headtopR",on:{"click":function($event){return _vm.$router.push({path: '/pages'})}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }